import { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './asset-class-filter.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import useSideRailContext from '../../../../stores/profile/use-side-rail-context';
import screenerAppContext from '../../../../stores/screener/screener-app-context';
import Checkbox from '../../../atoms/checkbox';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Icon from '../../../atoms/icon';
import { getModels } from '../../../../utils/sharedHelpers';
import { updateAssetFilter } from '../../../../stores/screener/screener-redux-store';
import { ASSET_CLASS_TO_MODEL, CHANNELS } from '../../../../shared/screener-constants';
import ButtonViewGlossary from '../../../atoms/button-view-glossary';

const className = augmentClassName(styles);

export const AssetClassFilter = ({
  filters,
  updateCheckBox,
  assetClassesFromPlan,
  isSearchedPlanInContext
}) => {
  const sideRail = useSideRailContext();
  const { channel } = useContext(screenerAppContext);
  const updateState = modelKey => {
    updateCheckBox(modelKey);
  };

  if (
    channel === CHANNELS.MYTIAA ||
    channel === CHANNELS.DYNAMICMICROSITES ||
    isSearchedPlanInContext
  ) {
    const currentAssetClassFilters = getModels(assetClassesFromPlan, filters, ASSET_CLASS_TO_MODEL);
    return (
      <Col {...className('py-6')}>
        <Row {...className('head-row')}>
          <h3 {...className('title')}> Asset Class </h3>
          <button
            {...className('px-3', 'btn-reset', 'mb-1')}
            // TIAA Analytics Tracking
            data-analytics-linkname="GlossaryExpand"
            data-analytics-section="component"
            data-analytics-componenttype="TextLink"
            // END TIAA Analytics Tracking
            aria-label="Open Glossary: Asset Class"
            onClick={() => sideRail.glossary.show()}
          >
            <Icon variant="QuestionMarkCircledSolid" />
          </button>
        </Row>
        {Object.entries(currentAssetClassFilters).map(([key, filter], index) => {
          return (
            <div
              key={filter.key}
              // TIAA Analytics Tracking
              data-analytics-linkname="Asset_class"
              data-analytics-section="component"
              data-analytics-componenttype="CustomFilters"
              // END TIAA Analytics Tracking
            >
              <CheckboxRow filter={filter} onChange={updateState} />
            </div>
          );
        })}
      </Col>
    );
  }

  return (
    <Col {...className('py-6')}>
      <Row {...className('head-row')}>
        <h3 {...className('title')}> Asset Class </h3>
        <ButtonViewGlossary glossarySection="Asset Class" solid isScreener />
      </Row>
      {Object.entries(filters).map(([key, filter], index) => {
        return (
          <div
            key={filter.key}
            // TIAA Analytics Tracking
            data-analytics-linkname="Asset_class"
            data-analytics-section="component"
            data-analytics-componenttype="CustomFilters"
            // END TIAA Analytics Tracking
          >
            <CheckboxRow filter={filter} onChange={updateState} />
          </div>
        );
      })}
    </Col>
  );
};

AssetClassFilter.propTypes = {
  filters: PropTypes.object,
  updateCheckBox: PropTypes.func,
  assetClassesFromPlan: PropTypes.array,
  isSearchedPlanInContext: PropTypes.bool
};

const CheckboxRow = ({ filter, onChange }) => {
  return (
    <div>
      <Row>
        <Col xs="auto">
          <Checkbox
            label={filter.value}
            ariaLabel={`${filter.label} asset class checkbox`}
            id={filter.key}
            disabled={false}
            onChange={onChange}
            checked={filter.checked}
            modelKey={filter.modelKey}
            checkedColor="#454545"
          />
        </Col>
        <Col xs="auto">
          <Form.Label {...className('check-label')} aria-label={filter.label} htmlFor={filter.key}>
            {filter.label}
          </Form.Label>
        </Col>
      </Row>
    </div>
  );
};

CheckboxRow.propTypes = {
  filter: PropTypes.object.isRequired,
  onChange: PropTypes.func
};

const mapStateToProps = state => {
  return {
    filters: state.filterReducer.filters.assetClassFilters,
    assetClassesFromPlan: state.filterReducer.assetClassesFromPlan,
    isSearchedPlanInContext: state.filterReducer.inputs.isSearchedPlanInContext
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCheckBox: modelKey => dispatch(updateAssetFilter(modelKey))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetClassFilter);
